import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './Login.css';

const SignupPage = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState({});
  const [step, setStep] = useState(1); 
  const [otp, setOtp] = useState('');

  const handleSignup = async (e) => {
    e.preventDefault();

    const form = e.target;
    const newUser = {
      name: form.name.value,
      email: form.email.value,
      password: form.password.value,
    };

    try {
      await axios.post('http://localhost:5000/api/users/signup', newUser);
      setUserData(newUser);
      setStep(2);
      alert('OTP sent to your email. Please verify.');
    } catch (error) {
      console.error(error);
      alert('Signup failed. Try a different email or check your input.');
    }
  };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    try {
      await axios.post('http://localhost:5000/api/users/verify-otp', {
        email: userData.email,
        otp,
      });
      alert('Signup complete! You can now log in.');
      navigate('/login');
    } catch (error) {
      console.error(error);
      alert('OTP verification failed. Please try again.');
    }
  };

  return (
    <div className="contact login">
      {step === 1 ? (
        <>
          <h2>Create a New Account</h2>
          <form onSubmit={handleSignup}>
            <input type="text" name="name" placeholder="Full Name" required />
            <input type="email" name="email" placeholder="Email" required />
            <input type="password" name="password" placeholder="Password" required />
            <button type="submit">Sign Up</button>
          </form>
        </>
      ) : (
        <>
          <h2>Verify OTP</h2>
          <form onSubmit={handleVerifyOtp}>
            <input
              type="text"
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              required
            />
            <button type="submit">Verify</button>
          </form>
        </>
      )}
    </div>
  );
};

export default SignupPage;
